import type { Move } from '../../move/move';
import type { PokemonV2 } from '../../pokemon/pokemon';
import type { damageRateMapper } from '../../types/damage';
import type { otherSetting } from '../../OtherSetting';

export interface ShellSideArmResult {
  selectedList: number[];
  selectedType: 'physical' | 'special';
  physical: { min: number; max: number };
  special: { min: number; max: number };
}

export function computeShellSideArmDamage(params: {
  move: Move;
  offencePokemon: PokemonV2;
  deffencePokemon: PokemonV2;
  rateMapper: damageRateMapper;
  loopHitNumber: number;
  otherSetting: otherSetting;
  isCritical: boolean;
  attackMode: boolean;
  calcWithRand: (
    move: Move,
    offencePokemon: PokemonV2,
    deffencePokemon: PokemonV2,
    rateMapper: damageRateMapper,
    loopHitNumber: number,
    otherSetting: otherSetting,
    isCritical: boolean,
    attackMode: boolean
  ) => number[];
}): ShellSideArmResult {
  const {
    move,
    offencePokemon,
    deffencePokemon,
    rateMapper,
    loopHitNumber,
    otherSetting,
    isCritical,
    attackMode,
    calcWithRand,
  } = params;

  // 物理技として計算
  const physicalMove = { ...move, damage_class_number: 2 } as Move; // MOVE_DAMAGE_CLASS_PHYSICAL
  const physicalDamageList = calcWithRand(
    physicalMove,
    offencePokemon,
    deffencePokemon,
    rateMapper,
    loopHitNumber,
    otherSetting,
    isCritical,
    attackMode
  );

  // 特殊技として計算
  const specialMove = { ...move, damage_class_number: 3 } as Move; // MOVE_DAMAGE_CLASS_SPECIAL
  const specialDamageList = calcWithRand(
    specialMove,
    offencePokemon,
    deffencePokemon,
    rateMapper,
    loopHitNumber,
    otherSetting,
    isCritical,
    attackMode
  );

  const physicalMaxDamage = Math.max(...physicalDamageList);
  const physicalMinDamage = Math.min(...physicalDamageList);
  const specialMaxDamage = Math.max(...specialDamageList);
  const specialMinDamage = Math.min(...specialDamageList);

  // 最大ダメージが同値なら物理扱いで採用する（判定ルールの明示）
  const selectedType = physicalMaxDamage >= specialMaxDamage ? 'physical' : 'special';
  const selectedList = selectedType === 'physical' ? physicalDamageList : specialDamageList;

  return {
    selectedList,
    selectedType,
    physical: { min: physicalMinDamage, max: physicalMaxDamage },
    special: { min: specialMinDamage, max: specialMaxDamage },
  };
}
